module.exports = __webpack_public_path__ + "media/images/icons/outlined/transaction-3dad1731b668f71109412eb38be9d2a1.svg";